import { historyReplace } from "@studiometa/js-toolkit/utils";
import { AbstractStorage } from "./AbstractStorage.js";
class URLStorage extends AbstractStorage {
  mode;
  constructor(store, mode = "search") {
    super(store);
    this.mode = mode;
  }
  get(key) {
    return this.store.get(key);
  }
  set(key, value) {
    this.store.set(key, value);
    historyReplace({ [this.mode]: this.mode === "search" ? this.store : this.store.toString() });
  }
  has(key) {
    return this.store.has(key);
  }
  delete(key) {
    this.store.delete(key);
  }
}
export {
  URLStorage
};
//# sourceMappingURL=URLStorage.js.map
